import { createAppRequest } from '@/services/request';
import type { CreateTagDto, QueryTagDto, Tag, UpdateTagDto } from './type';

const request = createAppRequest();

// 标签任务查询参数
export interface TagTaskQueryParams {
  page?: number;
  limit?: number;
  status?: string[];
  isCompleted?: boolean;
  priority?: string[];
  startDate?: string;
  endDate?: string;
  [key: string]: string | number | boolean | string[] | undefined;
}

// 任务标签管理 API
export const tagApi = {
  // 创建标签
  createTag: (data: CreateTagDto) =>
    request<Tag>('/bff/tags', {
      method: 'POST',
      data,
    }),

  // 获取标签列表
  getTags: (params?: QueryTagDto) => {
    const searchParams = new URLSearchParams();
    if (params?.page) {
      searchParams.append('page', params.page.toString());
    }
    if (params?.limit) {
      searchParams.append('limit', params.limit.toString());
    }
    if (params?.search) {
      searchParams.append('search', params.search);
    }
    if (params?.sortBy) {
      searchParams.append('sortBy', params.sortBy);
    }
    if (params?.order) {
      searchParams.append('order', params.order);
    }
    if (params?.isPublic !== undefined) {
      searchParams.append('isPublic', String(params.isPublic));
    }
    if (params?.creatorMemberId) {
      searchParams.append('creatorMemberId', params.creatorMemberId);
    }
    if (params?.sourceAppUuid) {
      searchParams.append('sourceAppUuid', params.sourceAppUuid);
    }
    if (params?.sourceSceneUuid) {
      searchParams.append('sourceSceneUuid', params.sourceSceneUuid);
    }
    if (params?.sourceObjectUuid) {
      searchParams.append('sourceObjectUuid', params.sourceObjectUuid);
    }

    return request<{ tags: Tag[]; total: number }>(
      `/bff/tags?${searchParams.toString()}`,
      {
        method: 'GET',
      },
    );
  },

  // 获取标签详情
  getTagById: (uuid: string) =>
    request<Tag>(`/bff/tags/${uuid}`, {
      method: 'GET',
    }),

  updateTag: (uuid: string, data: UpdateTagDto) =>
    request<Tag>(`/bff/tags/${uuid}`, {
      method: 'PATCH',
      data,
    }),

  shareTag: (uuid: string, sharedMemberUuids: string[]) =>
    request<Tag>(`/bff/tags/${uuid}/share`, {
      method: 'PATCH',
      data: {
        sharedMemberUuids,
      },
    }),

  deleteTag: (uuid: string) =>
    request<void>(`/bff/tags/${uuid}`, {
      method: 'DELETE',
    }),

  getPopularTags: (limit = 10) =>
    request<Tag[]>(`/bff/tags/popular?limit=${limit}`, {
      method: 'GET',
    }),

  searchTags: (keyword: string) =>
    request<{ tags: Tag[]; total: number }>(`/bff/tags?search=${keyword}`, {
      method: 'GET',
    }),

  getTagUsageStats: (uuid: string) =>
    request<{
      totalTasks: number;
      completedTasks: number;
      inProgressTasks: number;
      todoTasks: number;
      averageProgress: number;
    }>(`/bff/tags/${uuid}/statistics`, {
      method: 'GET',
    }),

  // 获取标签相关任务
  getTagTasks: ({
    uuid,
    params,
  }: {
    uuid: string;
    params?: TagTaskQueryParams;
  }) => {
    const searchParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined) {
          if (Array.isArray(value)) {
            value.forEach((v) => {
              searchParams.append(key, String(v));
            });
          } else {
            searchParams.append(key, String(value));
          }
        }
      });
    }
    const queryString = searchParams.toString();
    // const searchParams = new URLSearchParams();
    // if (params?.page) searchParams.append('page', params.page.toString());
    // if (params?.limit) searchParams.append('limit', params.limit.toString());
    // if (params?.status)
    //   params.status.forEach(s => searchParams.append('status', s));
    // if (params?.priority)
    //   params.priority.forEach(p => searchParams.append('priority', p));
    // if (params?.startDate) searchParams.append('startDate', params.startDate);
    // if (params?.endDate) searchParams.append('endDate', params.endDate);

    return request<{ tasks: any[]; total: number }>(
      `/bff/tags/${uuid}/tasks?${queryString}`,
      {
        method: 'GET',
      },
    );
  },
};
